<template>
  <div :key="index" class="cat-item-holder">
    <div class="cat-item">
      <div v-if="editable" class="dropdown-wrapper">
        <Dropdowns :options="actions" iconColor="black" />
      </div>
      <img :src="item.img[0]" alt class="cat-item-img" />
      <div class="cat-item-right">
        <div class="cat-item-name">{{item.name}}</div>
        <div class="cat-item-description">{{item.description}}</div>
        <div class="cat-item-price">{{item.price| currency('€')}}</div>
      </div>
    </div>
    <validation-observer v-slot="{invalid}">
      <b-modal :ok-disabled="invalid" @ok="editItem" :id="item.id" size="md" title="Edit Item">
        <form action>
          <TextInput
            :rules="`required|ItemName:${menuId}`"
            placeholder="Item Name"
            v-model="form.name"
          />
          <TextInput :rules="'required'" placeholder="Description" v-model="form.description" />
          <TextInput
            :rules="'required'"
            placeholder="Price"
            v-model="form.price"
          />
          <b-form-tags
            input-id="tags-pills"
            v-model="form.tags"
            tag-variant="primary"
            tag-pills
            size="lg"
            separator=" "
            remove-on-delete
            class="mb-2"
          ></b-form-tags>
          <FileUpload
            :onfile="fileChange"
            :value="file"
            :isLoading="fileLoading"
            @changed="fileChange($event)"
            label="upload background image"
            fileTypes="PNG up to 5MB"
            :progress="progress"
            :preview="previewURL(item.img,removeItems)"
            :deleteUrl="deleteUrl"
            :deleteFile="deleteFile"
          />
        </form>
      </b-modal>
    </validation-observer>
  </div>
</template>

<script>
import Dropdowns from "../components/Dropdown";
import { Progress } from "@/components";
import FileUpload from "../components/DragDropFileInput";
import TextInput from "./Inputs/TextInput";
import {ValidationObserver} from "vee-validate"
export default {
  props: { index: String, item: Object, menuId: String, editable: Boolean },
  components: {
    Dropdowns,
    [Progress.name]: Progress,
    FileUpload,
    TextInput,
    ValidationObserver
  },
  /* directives: {
    currencyf: {
      twoWay: true, // this transformation applies back to the vm
      bind: function(el, binding) {
        //console.log(currenctFunction(100));
        this.handler = function() {
      
      this.set(this.el.value=binding.value);
    }.bind(this);
        //this.el.addEventListener("input", this.handler);
      },
      unbind: function() {
        //this.el.removeEventListener("input", this.handler);
      }
    }
  }, */
  data() {
    return {
      form: {},
      file: [],
      formValues: "",
      removeItems: [],
      fileLoading: false,
      currenctFunction:"",
      actions: [
        {
          name: "Edit",
          icon: "Edit.svg",
          handler: this.onEdit,
          shouldRender: true,
          type: "Edit"
        },
        {
          name: `Delete`,
          icon: "delete.svg",
          handler: this.deleteItem,
          shouldRender: true,
          type: "Delete"
        }
      ]
    };
  },
  methods: {
    fileChange(file) {
      const formData = new FormData();
      formData.append("csvUpload", file);
      const formValues = formData;
      this.file = file;
    },
    deleteUrl(item) {
      this.removeItems.push(item);
    },
    deleteFile(index, item) {
      const tempFiles = [...this.file];
      tempFiles.splice(index, 1);
      this.file = [...tempFiles];
    },
    previewURL(items, removeItems) {
      return items.filter(x => !removeItems.includes(x));
    },
    onEdit() {
      this.$bvModal.show(this.item.id);
    },
    editItem(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.$store
        .dispatch("Item/editItem", {
          form: this.form,
          images: this.previewURL(this.item.img, this.removeItems),
          itemId: this.item.id,
          file: this.file
        })
        .then(() => {
          this.$bvModal.hide(this.item.id);
          this.file = [];
        });
    },
    deleteItem() {
      this.$store.dispatch("Menu/deleteMenuItem",  this.item.id);
    }
  },
  computed: {
    progress() {
      return this.$store.state.Menu.uploadValue;
    }
  },
  mounted() {
    this.currenctFunction=this.$options.filters.currency
    this.form = {
      name: this.item.name,
      price: this.item.price,
      description: this.item.description,
      tags: this.item.tags
    };
  },
  
};
</script>

<style>
.cat-item {
  display: grid;
  grid-template-columns: 70px 1fr;
  height: 70px;
  grid-gap: 10px;
  position: relative;
}

.cat-item .dropdown-wrapper {
  color: white;
  position: absolute;
  top: -30px;
  right: 0px;
  z-index: 3;
}

.cat-item-img {
  border-radius: 5px;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.cat-item-bottom {
  display: flex;
  justify-content: flex-end;
}

.cat-item-holder .cat-item-bottom .mcat-top-btn {
  color: #2ca8ff;
  margin: 0;
  padding: 0 10px;
}

.mcat-wrapper .mcat-top .mcat-top-btn:hover {
  color: #2ca8ff;
}

.cat-item .cat-item-name {
  font-weight: 600;
  font-size: 18px;
  line-height: 20px;
}
.cat-item .cat-item-price {
  font-size: smaller;
}

.cat-item-description {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cat-item-right {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>